/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__